import React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function Tip({ width = 64, height = 16, ...delegated }: Props) {
  return (
    <Wrapper
      {...delegated}
      fill="none"
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ width, height }}
    >
      <path
        d={`
        M 0 0
        C ${width / 2} 0
          ${width / 2 - width / 8} ${height}
          ${width / 2} ${height}
        C ${width / 2 + width / 8} ${height}
          ${width / 2} 0
          ${width} 0
      `}
      />
    </Wrapper>
  );
}

const Wrapper = styled.svg`
  display: block;

  path {
    fill: var(--background-color);
  }
`;

export default Tip;
